import Menus from "../Menus"

const HelpTopicFactures = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Paiements, tarification et remboursements", link: '/topics/paiement'},
    { label: 'Factures et reçus', link: '/topics/paiement/factures'},
  ]

  const multiMenus = [
    {title: null, filter: 'HelpTopicFactures'},
  ]

  return <Menus goBackLinks={goBackLinks} multiMenus={multiMenus} desiredOrder={[48]}/>
}

export default HelpTopicFactures